const UNIT = (
  <>
    <span className="ticker-unit">
      <span className="black">reaching</span> <span className="green">yoo</span> <span className="black">now</span>
    </span>
    <span className="ticker-dot" />
  </>
);

const ReachingYooTicker = () => (
  <>
    <div className="ticker-outer">
      <div className="ticker-inner">
        {Array.from({ length: 28 }).map((_, i) => (
          <span key={i} className="contents">{UNIT}</span>
        ))}
      </div>
    </div>
    <style>{`
      .ticker-outer {
        overflow: hidden;
        position: relative;
        padding: 18px 0;
        width: 100%;
      }
      .ticker-inner {
        display: inline-flex;
        align-items: center;
        white-space: nowrap;
        animation: reaching-yoo-ticker 24s linear infinite;
      }
      @keyframes reaching-yoo-ticker {
        0%   { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
      .ticker-unit {
        display: inline-flex;
        align-items: center;
        font-family: 'Inter', sans-serif;
        font-weight: 700;
        font-size: 30px;
        letter-spacing: -0.02em;
        gap: 8px;
        padding-right: 4px;
      }
      .ticker-unit .black { color: #111111; }
      .ticker-unit .green { color: #00C4A0; }
      .ticker-dot {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #00C4A0;
        margin: 0 22px;
        flex-shrink: 0;
      }
    `}</style>
  </>
);

export default ReachingYooTicker;